import {MapsAPILoader} from '@agm/core';
import {Location} from '@angular/common';
import {Component, HostListener, OnDestroy, OnInit, ViewChild, AfterViewInit, ElementRef, NgZone} from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {MatDialog} from '@angular/material/dialog';
import {MatSelect} from '@angular/material/select';
import {ActivatedRoute, Router} from '@angular/router';
import {Update} from '@ngrx/entity';
import {select, Store} from '@ngrx/store';
import {BehaviorSubject, combineLatest, Observable, of, ReplaySubject, Subject, Subscription} from 'rxjs';
import {delay, map, startWith, take, takeUntil} from 'rxjs/operators';
import {environment} from '../../../../../../environments/environment';
import {each, uniq} from 'lodash';
import {TranslateService} from '@ngx-translate/core';
// tslint:disable-next-line: max-line-length
import {
    AcSource, AssetClassBuildingInformation, AssetClassOfficeFacilityModel, AssetClassOfficeModel,
    AssetClassOfficeOnServerCreated, AssetClassOfficeOnServerUpdated, AssetClassOfficesService, AssetClassTenure,
    selectLastCreatedAssetClassOfficeId, AssetClassSizeModel, OfficeExternalAreaModel,
} from '../../../../../core/comparable';
// tslint:disable-next-line: max-line-length
import {
    AllGradesRequested,
    AllHandoverStandardsRequested,
    AllOfficeLayoutsRequested,
    Grade,
    OfficeLayout,
    selectAllGrades,
    selectAllHandoverStandards,
    selectAllOfficeLayouts,
    ExternalArea,
    AllExternalAreasRequested,
    selectAllExternalAreas,
    FloorType,
    AllFloorTypesRequested,
    selectAllFloorTypes,
    WindowType,
    AllWindowTypesRequested,
    selectAllWindowTypes,
    selectOfficeLayoutsActionLoading,
    HandoverStandard,
    AllStateRepairsRequested,
    selectAllStateRepairs,
    StateRepair,
    BuildingType,
    AllBuildingTypesRequested,
    selectAllBuildingTypes,
    selectAllUnitAreaMeasurements,
    AllUnitAreaMeasurementsRequested,
} from '../../../../../core/linked-tables';
import {AppState} from '../../../../../core/reducers';
import {LayoutUtilsService, MessageType, TypesUtilsService} from '../../../../../core/_base/crud';
import {LayoutConfigService, SubheaderService} from '../../../../../core/_base/layout';
import {UploadFileComponent} from '../../../shared_components/upload-file/upload-file.component';
import {BuildingInformationComponent} from '../../../shared_components/building-information/building-information.component';
import {FacilitiesSubListComponent} from '../../../shared_components/facilities/list/facilities-sub-list.component';
import {
    CityModel,
    CountryModel,
    selectAllCountries,
    selectCitiesByCountryId,
    AllCountriesRequested,
    AllCitiesRequested
} from '../../../../../core/admin';
import { CountryEditComponent } from '../../../admin-management/countries/country-edit/country-edit.component';
import { ComparablesRadioButtonValues } from "src/app/core/comparable/_models/RadioButtonValues";
import { AcDocumentUploadComponent } from '../../../shared_components/ac-document-upload/ac-document-upload.component';
import { ComparableLocationComponent } from 'src/app/components/location/comparable-location/comparable-location.component';
import { ConsiderationAndSourceComponent } from '../../_sub/consideration-and-source/consideration-and-source.component';
import { BuildingSectionComponent } from '../../../shared_components/building-section/building-section.component';
import { SubCategoryModel } from 'src/app/core/linked-tables/_models/sub-category.model';
import { SubTypeCategoryModel } from 'src/app/core/linked-tables/_models/sub-type-category.model';
import { AllSubCategorysRequested } from 'src/app/core/linked-tables/_actions/sub-category.actions';
import { selectAllSubCategorys } from 'src/app/core/linked-tables/_selectors/sub-category.selectors';
import { AllSubTypeCategorysRequested } from 'src/app/core/linked-tables/_actions/sub-type-category.actions';
import { selectAllSubTypeCategorys } from 'src/app/core/linked-tables/_selectors/sub-type-category.selectors';
import { InternalAspectsComponent } from '../../../shared_components/internal-aspects/internal-aspects.component';
import { AcGroundsComponent } from '../../../shared_components/ac-grounds/ac-grounds.component';
import { AccommodationLayoutTableComponent } from '../../../shared_components/accommodation-layout-table/accommodation-layout-table.component';
import { TabHeader } from '../../../shared_components/tab-header/tab-header.component';
import { BuildingFormComponent } from '../../../shared_components/building-form/building-form.component';
import {v4 as uuidv4} from 'uuid'
import { AssetClassSize } from 'src/app/core/v2/types';
import { currentUser } from 'src/app/core/mad-auth/mad-auth.store';
import { EsgIndicatorsComponent } from '../../../mad_shared/esg-indicators/esg-indicators.component';
import { EsgIndicator } from 'src/app/core/v2/state/esg-indicator/type';
import { LocationInfo, toCoordinate } from 'src/app/core/v3/location';
import { CoordinatePoint } from 'src/app/core/v3/coordinate-points';
import { SubCategoryEntryService } from 'src/app/core/linked-tables/_services/sub-category-entry.service';

@Component({
    selector: 'kt-office-edit',
    templateUrl: './office-edit.component.html',
    styleUrls: ['./office-edit.component.scss', '../../complex-btn.scss'],
})
export class OfficeEditComponent implements OnInit, OnDestroy {
    @ViewChild(ComparableLocationComponent, {static: false}) 
    mapLocationComponent: ComparableLocationComponent;
    locationInfo: LocationInfo | null = null;

    @ViewChild('simple')
    public uploadFileComponent: UploadFileComponent;
    @ViewChild('buildingPic')
    public buildingFileComponent: UploadFileComponent;
    @ViewChild(InternalAspectsComponent, {static: false})
    internalAspectComponent: InternalAspectsComponent;
    @ViewChild(AcGroundsComponent, {static: false})
    acGroundsComponent: AcGroundsComponent;
    @ViewChild(AcDocumentUploadComponent, {static: false})
    acDocumentUploadComponent: AcDocumentUploadComponent;
    @ViewChild(ConsiderationAndSourceComponent, {static: false})
    considerationAndSourceComponent: ConsiderationAndSourceComponent;
    @ViewChild(BuildingSectionComponent, {static: false})
    buildingSectionComponent: BuildingSectionComponent;
    @ViewChild(AccommodationLayoutTableComponent, {static: false})
    accommodationLayoutTable: AccommodationLayoutTableComponent;
    @ViewChild(BuildingFormComponent, {static: false})
    buildingFormComponent: BuildingFormComponent;
    @ViewChild(EsgIndicatorsComponent, {static: false})
    esgIndicatorComponent: EsgIndicatorsComponent;

    ac: AssetClassOfficeModel;
    form: UntypedFormGroup;
    saveState: boolean;

    loading$: Observable<boolean>;
    
    protected _onDestroy = new Subject<void>();
    formSelectionCtrl: UntypedFormControl = new UntypedFormControl();
    isComplexForm: boolean = false;
    hasFormErrors: boolean = false;
    isShown: boolean = true;
    markerLat: number;
    markerLng: number;
    centerLat = null;
    centerLng = null;
    subCategories: SubCategoryModel[] = [];
    filteredSubCategories: SubCategoryModel[] = [];
    public filteredSubTypeCategories: BehaviorSubject<SubTypeCategoryModel[]> = new BehaviorSubject([]);
    subTypeCategories: SubTypeCategoryModel[] = [];
    handoverStandards: HandoverStandard[] = [];
    stateOfRepairs: StateRepair[] = [];
    grades: Grade[] = [];
    buildingTypes: BuildingType[] = [];
    private _floors$: BehaviorSubject<number[]> = new BehaviorSubject([]);
    public floors$: Observable<number[]> = this._floors$.asObservable();
    aboveFloor$: BehaviorSubject<number> = new BehaviorSubject(null);
    belowFloor$: BehaviorSubject<number> = new BehaviorSubject(null);
    tenuresSubject = new BehaviorSubject<AssetClassTenure[]>([])
    sizesSubject = new BehaviorSubject<AssetClassSizeModel[]>([]);
    sizes$ = combineLatest([ 
      this.store.select(selectAllUnitAreaMeasurements),
      this.sizesSubject.asObservable()
    ]).pipe(
      map(([unitAreaMeasurements, sizes]) => {
        const items: AssetClassSize[] = sizes.map(size => ({
          id: size.id,
          uid: size.uid,
          size: size.size,
          standardMeasurementName: size.standard_measurement_name,
          unitAreaMeasurementAcronym: unitAreaMeasurements.find(item => item.id === size.unit_of_area_measurement_id)?.acronym
        }))
        return items
      })
    )
    showTitleRequiredError$: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public hasParcel = of(false);
    public comps = new BehaviorSubject([]);
    public considerationError$ = new BehaviorSubject(undefined);
    selectedTab = 0;
    selectedtabchange: BehaviorSubject<number> = new BehaviorSubject(0);
    selectedtabchange$: Observable<number> = this.selectedtabchange.asObservable();
    tabHeaders: TabHeader[] = [
      {label: 'Location & building', disabled: of(false)},
      {label: 'Property information', disabled: of(false)},
      {label: 'ESG indicators', disabled: of(false)},
      {label: 'Lease & sale information', disabled: of(false)},
      {label: 'Pictures & documents', disabled: of(false)},
    ]
    error:any = {
      msg: ' Missing Fields in total:',
      fields: []
    }
    timezoneOffset: string | null
    onTimezoneChange(offset: string) {
      this.timezoneOffset = offset
    }

    get floorLocationFormControl() {
      if (!this.form) return null
      return this.form.controls.floor_details
    }

    private readonly _currentUser$ = this.store.select(currentUser)
    userUnitOfMeasurementId$ = this._currentUser$.pipe(
      map(user => {
        if (!user) return null 
        return user.settings.unit_of_measurement_id
      })
    )

    private _formState$ = new BehaviorSubject({
      map_location: {
        invalid: undefined,
        fields: 0
      },
      building: {
        invalid: undefined,
        fields: 0
      },
      about_property: {
        invalid: undefined,
        fields: 0
      },
      internal_aspects: {
        invalid: undefined,
        fields: 0
      },
      ac_grounds: {
        invalid: undefined,
        fields: 0
      },
      size: {
        invalid: undefined,
        fields: 0
      },
      considerations: {
        invalid: undefined,
        fields: 0
      },
      pictures: {
        invalid: undefined,
        fields: 0
      },
      building_pictures: {
        invalid: undefined,
        fields: 0
      }
    })
    formTabHeaders$ = this._formState$.asObservable().pipe(
      map(state => {
        let locationState = 'required'
        let locationFields = 0
        if (
          state.map_location.invalid ||
          state.building.invalid
        ) {
          locationState = 'error'
          locationFields = 
            state.map_location.fields +
            state.building.fields
        } else if (
          state.map_location.invalid === false &&
          state.building.invalid === false
        ) {
          locationState = 'complete'
        }

        let propertyState = 'required'
        let propertyFields = 0
        if (
          state.about_property.invalid ||
          state.internal_aspects.invalid ||
          state.ac_grounds.invalid ||
          state.size.invalid
        ) {
          propertyState = 'error'
          propertyFields =
            state.about_property.fields +
            state.internal_aspects.fields +
            state.ac_grounds.fields + 
            state.size.fields
        } else if (
          state.about_property.invalid === false &&
          state.internal_aspects.invalid === false &&
          state.ac_grounds.invalid === false &&
          state.size.invalid === false
        ) {
          propertyState = 'complete'
        }

        let considerationState = 'required'
        let considerationFields = 0
        if (state.considerations.invalid) {
          considerationState = 'error'
          considerationFields = state.considerations.fields
        } else if (state.considerations.invalid === false) {
          considerationState = 'complete'
        }

        let picturesState = 'required'
        let picturesFields = 0
        if (
          state.pictures.invalid ||
          state.building_pictures.invalid
        ) {
          picturesState = 'error'
          picturesFields = state.pictures.fields + state.building_pictures.fields
        } else if (state.pictures.invalid === false && state.building_pictures.invalid === false) {
          picturesState = 'complete'
        }

        return [
          {
            label: 'Location & Building',
            state: locationState,
            requiredFields: locationFields
          },
          {
            label: 'Property Information',
            state: propertyState,
            requiredFields: propertyFields
          },
          {
            label: 'ESG Indicators',
            state: 'default',
            requiredFields: 0
          },
          {
            label: 'Lease & Sale Information',
            state: considerationState,
            requiredFields: considerationFields
          },
          {
            label: 'Pictures & Documents',
            state: 'default',
            requiredFields: 0
          }
        ]
      })
    )
    private validateClicked = false
    
    /**
     * Component constructor
     *
     * @param assetClassOfficesService: AssetClassOfficesService
     * @param activatedRoute: ActivatedRoute
     * @param router: Router
     * @param fb: FormBuilder
     * @param location: Location
     * @param subheaderService: SubheaderService
     * @param typesUtilsService: TypesUtilsService
     * @param layoutUtilsService: LayoutUtilsService
     * @param store: Store
     * @param dialog: Dialog
     * @param mapsAPILoader: MapsAPILoader
     * @param layoutConfigService: LayoutConfigService
     * @param ngZone: NgZone
     */
    constructor(public assetClassOfficesService: AssetClassOfficesService,
                private activatedRoute: ActivatedRoute,
                private router: Router,
                private fb: UntypedFormBuilder,
                private location: Location,
                private subheaderService: SubheaderService,
                public typesUtilsService: TypesUtilsService,
                private layoutUtilsService: LayoutUtilsService,
                private store: Store<AppState>,
                public dialog: MatDialog,
                private mapsAPILoader: MapsAPILoader,
                private layoutConfigService: LayoutConfigService,
                private ngZone: NgZone,
                private translate: TranslateService,
                private subCategoryEntryService: SubCategoryEntryService) {
        this.saveState = false;
        // this.fileType = 'image/*';
    }

    ngOnInit() {
      const routeSubscription = this.activatedRoute.params.subscribe(params => {
        const id = params.office_id;
        if (id && id > 0) {
          this.activatedRoute.data.subscribe(data => {
            const res = data.data;
            this.ac = res.data;
            this.isComplexForm = this.ac.formType == 1;
            this._floors$.next(this._getFloorsFrom(this.ac.floor_details));
            const deepCopiedSizes = _deepCopy(this.ac.sizes)
              .map(size => {
                size.uid = uuidv4()
                return size
              })
            const deepCopiedTenures = _deepCopy(this.ac.tenures)
              .map(tenure => {
                const rentSizeUuid = deepCopiedSizes.find(size => size.id === tenure.rent_size_id)?.uid
                const expensesSizeUuid = deepCopiedSizes.find(size => size.id === tenure.expenses_size_id)?.uid
                tenure.rent_size_uid = rentSizeUuid
                tenure.expenses_size_uid = expensesSizeUuid
                return tenure
              })
            this.tenuresSubject.next(deepCopiedTenures)
            this.sizesSubject.next(deepCopiedSizes);
            this.markerLat = Number(res.data.locationData.latitude);
            this.markerLng = Number(res.data.locationData.longitude);
            this.centerLng = this.markerLng;
            this.centerLat = this.markerLat;
            this._setLocationInfo();
            this.createForm();
          });
        } else {
          this.ac = new AssetClassOfficeModel();
          this.ac.clear();
          this.createForm();
        }
      });

      this.store.dispatch(new AllUnitAreaMeasurementsRequested())
      this.store.dispatch(new AllSubCategorysRequested());
      this.store.select(selectAllSubCategorys).pipe(takeUntil(this._onDestroy))
        .subscribe(res => {
          this.subCategories = res ? res : [];
          this.filteredSubCategories = this._filterSubCategories(this.ac.sub_type_category_id);
        });

      this.store.dispatch(new AllSubTypeCategorysRequested());
      this.store.pipe(
        select(selectAllSubTypeCategorys), takeUntil(this._onDestroy))
        .subscribe(res => {
          this.subTypeCategories = [];
          if (res) {
            this.subTypeCategories = res;
            this.filteredSubTypeCategories.next(this._filterSubTypeCategories(3));
          }
        });

      this.store.dispatch(new AllHandoverStandardsRequested());
      this.store.pipe(select(selectAllHandoverStandards), takeUntil(this._onDestroy))
        .subscribe(res => {
          this.handoverStandards = res ? res : [];
        });
      this.store.dispatch(new AllStateRepairsRequested());
      this.store.pipe(select(selectAllStateRepairs), takeUntil(this._onDestroy))
        .subscribe(res => {
          this.stateOfRepairs = res ? res : [];
        });

      this.store.dispatch(new AllGradesRequested());
      this.store.pipe(select(selectAllGrades), takeUntil(this._onDestroy))
        .subscribe(res => this.grades = res ? res : []);
      this.store.dispatch(new AllBuildingTypesRequested());
      this.store.select(selectAllBuildingTypes).pipe(takeUntil(this._onDestroy)).subscribe(res => {
          this.buildingTypes = res ? res : [];
      });

      this.loading$ = this.store.pipe(select(selectOfficeLayoutsActionLoading));
    }

    private _changeValidation(fields: string[], hasValidation: boolean) {
      const controls = this.form.controls;
      fields.forEach(field => {
        if (hasValidation) {
          controls[field].setValidators([Validators.required]);
        } else {
          controls[field].clearValidators();
        }
        controls[field].updateValueAndValidity();
      })
    }
    createForm() {
      this.form = this.fb.group({
        sub_type_category_id: [this.ac.sub_type_category_id],
        sub_category_id: [this.ac.sub_category_id],
        handover_standard_id: [this.ac.handover_standard_id],
        floor_details: [this.ac.floor_details && this.ac.floor_details.length > 0 
            ? this.ac.floor_details.split(',')
            : ''],
        state_of_repair_id: [this.ac.state_of_repair_id],
        state_of_repair_description: [this.ac.state_of_repair_description],
        general_desc: [this.ac.property_general_desc],
        building_name: [this.ac.building_info.building_name],
        building_type: [this.ac.building_info.building_type],
        building_type_comment: [this.ac.building_info.building_type_comment]
      });
      this.formSelectionCtrl.setValue(this.ac.formType);
      this.formSelectionCtrl.updateValueAndValidity();
      this.formSelectionCtrl.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(val => {
        if (val == 1) {
          this.isComplexForm = true;
        } else {
          this.isComplexForm = false;
        }
        if (this.form) {
          // this._changeValidation(['building_type'], !this.isComplexForm);

          this.ngZone.onStable.pipe(take(1)).subscribe(() => {
            if (this.validateClicked) {
              this.onSubmit(true)
            }
          })
        }
      });
      this.form.controls.sub_type_category_id.valueChanges.pipe(
        startWith(this.form.controls.sub_type_category_id.value),
        takeUntil(this._onDestroy)
      ).subscribe(val => {
        this.filteredSubCategories = this._filterSubCategories(val)

        if (this.filteredSubCategories.length == 0) {
          this.form.controls.sub_category_id.clearValidators();
        } else {
          this.form.controls.sub_category_id.setValidators([Validators.required]);
        }
        this.form.controls.sub_category_id.updateValueAndValidity();
      })
    }
    onFloorAdd(event) {
        const floorStr = event.value;
        const floors = this._getFloors(floorStr);
        const _floors = this._floors$.value;
        floors.forEach(floor => {
            if (_floors.findIndex(f => f == floor) > -1) {
                return;
            }
            _floors.push(floor);
        });
        _floors.sort();
        this._floors$.next(_floors);
    }
    onFloorRemove(event) {
        const floors = this._getFloors(event);
        const _floors = this._floors$.value;
        floors.forEach(floor => {
            const index = _floors.findIndex(f => f == floor);
            if (index > -1) {
                _floors.splice(index, 1);
            }
        });
        _floors.sort();
        this._floors$.next(_floors);
    }
    private _getFloorsFrom(data: string) {
      if (data == null) {
        return [];
      }
        const floorRaws = data.split(',');
        let floors = [];
        floorRaws.forEach(raw => {
            const _floors = this._getFloors(raw);
            _floors.forEach(f => floors.push(f));
        });
        floors = uniq(floors);
        return floors;
    }
    private _getFloors(raw: string): number[] {
      if (raw == null) {
        return [];
      }
        const splits = raw.split(':');
        const floors: number[] = []
        if (splits.length == 2) {
            const lower = parseInt(splits[0]);
            const upper = parseInt(splits[1]);
            for (let i = lower; i <= upper; i++) {
                floors.push(i);
            }
        } else {
            floors.push(parseInt(splits[0]));
        }
        return floors;
    }

    private _filterSubCategories(stcId: number) {
      if (stcId == null) {
        return [];
      }
      return this.subCategories.filter(item => item.sub_type_category_id == stcId);
    }
    private _filterSubTypeCategories(typeId: number) {
      return this.subTypeCategories.filter(item => item.property_sub_type_id == typeId);
    }


    onAddSubTypeCategory() {
        this.subCategoryEntryService.addSubTypeCategory(this.form.controls.sub_type_category_id, 3)
            .pipe(takeUntil(this._onDestroy))
            .subscribe();
    }

    onAddSubCategory() {
        const subTypeCategoryControl = this.form.controls.sub_type_category_id;
        this.subCategoryEntryService.addSubCategory(this.form.controls.sub_category_id, subTypeCategoryControl.value)
            .pipe(takeUntil(this._onDestroy))
            .subscribe(created => {
                if (created) {
                    this.filteredSubCategories = this._filterSubCategories(subTypeCategoryControl.value);
                }
            });
    }

    ngOnDestroy(): void {
      this._onDestroy.next();
      this._onDestroy.complete();
    }

  onCenterChange(locationData) {
    this.centerLat = locationData.latitude;
    this.centerLng = locationData.longitude;
    this.ac = Object.assign({}, this.ac, {
      locationData: {
        ...this.ac.locationData,
        latitude: locationData.latitude === null ? null : (Number(locationData.latitude)),
        longitude: locationData.longitude === null ? null : (Number(locationData.longitude)),
        address: locationData.address,
        location_grade_id: locationData.location_grade_id,
        zip_code: locationData.zip_code,
        city_id: locationData.city_id,
        location_surrounding: locationData.location_surrounding
      }
    });
  }

    onPicChange(pics: {pictures: any[], picture: any}) {
      this.ac = Object.assign({}, this.ac, {
        building_info: {
          ...this.ac.building_info,
          pictures: pics.pictures,
          picture: pics.picture
        }
      })
    }

    getComponentTitle(): string {
      if (this.ac && this.ac.id) {
        return `Edit Office "${this.ac.ref_num}"`;
      }
      return 'Add Office';
    }

    back() {
      this.location.back();
    }

    /**
     * On Submit
     */
    onSubmit(status: boolean) {
      this.validateClicked = status
      let errorFields = [];
      this.hasFormErrors = false;
      this.considerationError$.next(false);
      this.showTitleRequiredError$.next(false);

      let formState = this._formState$.getValue()
      
      if (this.mapLocationComponent) {
        if (status && this.mapLocationComponent.validate()) {
          this.hasFormErrors = true;
          errorFields = [...errorFields, ...this.mapLocationComponent.errorFields];
          formState = {
            ...formState,
            map_location: {
              invalid: true,
              fields: this.mapLocationComponent.errorFields.length
            }
          }
        } else {
          formState = {
            ...formState,
            map_location: {
              invalid: false,
              fields: 0
            }
          }
        }
      }
      if (this.buildingSectionComponent) {
        if (status && this.buildingSectionComponent.validate()) {
          this.hasFormErrors = true;
          errorFields = [...errorFields, ...this.buildingSectionComponent.errorFields];
        }
      }

      if (this.buildingFormComponent) {
        if (status && this.buildingFormComponent.validate()) {
          this.hasFormErrors = true;
          errorFields = [...errorFields, ...this.buildingFormComponent.errorFields.map(f => 'building_form_' + f)];
          formState = {
            ...formState,
            building: {
              invalid: true,
              fields: this.buildingFormComponent.errorFields.length
            }
          }
        } else {
          formState = {
            ...formState,
            building: {
              invalid: false,
              fields: 0
            }
          }
        }
      } else {
        formState = {
          ...formState,
          building: {
            invalid: false,
            fields: 0
          }
        }
      }

      const controls = this.form.controls;
      let formErrorFields = []
      if (status && this.form.invalid) {
        Object.keys(controls).forEach(cname => {
          if (!controls[cname].valid) {
            errorFields = [...errorFields, cname];
            formErrorFields = [...formErrorFields, cname]
          }
          controls[cname].markAsTouched();
        })
        this.hasFormErrors = true;
        formState = {
          ...formState,
          about_property: {
            invalid: true,
            fields: formErrorFields.length
          }
        }
      } else {
        formState = {
          ...formState,
          about_property: {
            invalid: false,
            fields: 0
          }
        }
      }
      if (status && this.sizesSubject.value.length == 0) {
        this.hasFormErrors = true;
        errorFields = [...errorFields, 'size'];
        formState = {
          ...formState,
          size: {
            invalid: true,
            fields: 1
          }
        }
      } else {
        formState = {
          ...formState,
          size: {
            invalid: false,
            fields: 0
          }
        }
      }
      if (this.internalAspectComponent) {
        if (status && this.internalAspectComponent.validate()) {
          this.hasFormErrors = true;
          errorFields = [...errorFields, ...this.internalAspectComponent.errorFields];
          formState = {
            ...formState,
            internal_aspects: {
              invalid: true,
              fields: this.internalAspectComponent.errorFields.length
            }
          }
        } else {
          formState = {
            ...formState,
            internal_aspects: {
              invalid: false,
              fields: 0
            }
          }
        }
      } else {
        formState = {
          ...formState,
          internal_aspects: {
            invalid: false,
            fields: 0
          }
        }
      }
      if (status && this.acGroundsComponent.validate()) {
        this.hasFormErrors = true;
        errorFields = [...errorFields, ...this.acGroundsComponent.errorFields];
        if (this.acGroundsComponent.errorFields.length == 0) {
          errorFields = [...errorFields, 'grounds'];
        }
        formState = {
          ...formState,
          ac_grounds: {
            invalid: true,
            fields: this.acGroundsComponent.errorFields.length
          }
        }
      } else {
        formState = {
          ...formState,
          ac_grounds: {
            invalid: false,
            fields: 0
          }
        }
      }

      if (status && !this.considerationAndSourceComponent.validate()) {
        this.hasFormErrors = true;
        this.considerationError$.next(true);
        errorFields = [...errorFields, 'consideration'];
        formState = {
          ...formState,
          considerations: {
            invalid: true,
            fields: 1
          }
        }
      } else {
        formState = {
          ...formState,
          considerations: {
            invalid: false,
            fields: 0
          }
        }
      }

      if (status && this.uploadFileComponent.uploadFiles.length == 0) {
        // this.hasFormErrors = true;
        // errorFields = [...errorFields, 'pic'];
        // formState = {
        //   ...formState,
        //   pictures: {
        //     invalid: true,
        //     fields: 1
        //   }
        // }
      } else {
        let hasError = false
        const uploadedFiles = this.uploadFileComponent.uploadFiles;
        uploadedFiles.forEach(file => {
          if (file.title === null || file.title === '') {
            this.hasFormErrors = true;
            hasError = true
            this.showTitleRequiredError$.next(true);
            errorFields = [...errorFields, 'pic'];
          }
        })
        if (hasError) {
          formState = {
            ...formState,
            pictures: {
              invalid: true,
              fields: 1
            }
          }
        } else {
          formState = {
            ...formState,
            pictures: {
              invalid: false,
              fields: 0
            }
          }
        }
      }
      if (status && this.buildingFileComponent && this.buildingFileComponent.uploadFiles.length == 0) {
        // this.hasFormErrors = true;
        // errorFields = [...errorFields, 'b_pic'];
        // formState = {
        //   ...formState,
        //   building_pictures: {
        //     invalid: true,
        //     fields: 1
        //   }
        // }
      } else if (this.buildingFileComponent && this.buildingFileComponent.uploadFiles.length > 0) {
        let hasError = false
        const uploadedFiles = this.buildingFileComponent.uploadFiles;
        uploadedFiles.forEach(file => {
          if (file.title === null || file.title === '') {
            this.hasFormErrors = true;
            hasError = true
            this.showTitleRequiredError$.next(true);
            errorFields = [...errorFields, 'b_pic'];
          }
        })
        if (hasError) {
          formState = {
            ...formState,
            building_pictures: {
              invalid: true,
              fields: 1
            }
          }
        } else {
          formState = {
            ...formState,
            building_pictures: {
              invalid: false,
              fields: 0
            }
          }
        }
      } else if (!this.buildingFileComponent) {
        formState = {
          ...formState,
          building_pictures: {
            invalid: false,
            fields: 0
          }
        }
      }

      let esgIndicatorValues: EsgIndicator | null = null
      if (this.esgIndicatorComponent) {
        const esgIndicatorResult = this.esgIndicatorComponent.submit(!status)
        if (esgIndicatorResult.type === 'success') {
          esgIndicatorValues = esgIndicatorResult.values
        } else if (esgIndicatorResult.type === 'error') {
          this.hasFormErrors = true
          errorFields = [...errorFields, esgIndicatorResult.errors]
        }
      }
      this._formState$.next(formState)
      if (this.hasFormErrors) {
        this.error.fields = errorFields;
        this.layoutUtilsService.showFormError()
        return;
      }

      const editedAssetClassOffice = this.prepareAssetClassOffice(status, esgIndicatorValues);

      if (editedAssetClassOffice.id > 0) {
        this.updateAssetClassOffice(editedAssetClassOffice);
      } else {
        this.createAssetClassOffice(editedAssetClassOffice);
      }
    }

    /**
     * Returns prepared assignment
     */
    prepareAssetClassOffice(isComplete: boolean, esgIndicatorValues: EsgIndicator): AssetClassOfficeModel {
      const _assetClassOffice = new AssetClassOfficeModel();
      _assetClassOffice.clear();
      _assetClassOffice.id = this.ac.id;
      _assetClassOffice.status = isComplete ? 1 : 0;
      _assetClassOffice.formType = this.formSelectionCtrl.value;

      const controls = this.form.controls;
      if (this.mapLocationComponent) {
        // Keep fields the location component does not capture (address, grade, land
      // boundary…) so they survive a save from this form.
      _assetClassOffice.locationData = { ..._assetClassOffice.locationData, ...this.mapLocationComponent.getData() };
      }

      if (this.buildingSectionComponent) {
        _assetClassOffice.building_info = this.buildingSectionComponent.getDataForComparable();
      }

      _assetClassOffice.sub_type_category_id = controls.sub_type_category_id.value;
      _assetClassOffice.sub_category_id = controls.sub_category_id.value;
      _assetClassOffice.handover_standard_id = controls.handover_standard_id.value;
      _assetClassOffice.floor_details = controls.floor_details.value.length > 0 
          ? controls.floor_details.value.join(',') 
          : '';
      _assetClassOffice.state_of_repair_id = controls.state_of_repair_id.value;
      _assetClassOffice.state_of_repair_description = controls.state_of_repair_description.value;
      _assetClassOffice.property_general_desc = controls.general_desc.value;
      if (!this.isComplexForm) {
        _assetClassOffice.building_info.building_type = controls.building_type.value;
        _assetClassOffice.building_info.building_type_comment = controls.building_type_comment.value;
      }
      _assetClassOffice.accommodation = this.accommodationLayoutTable ? {...this.accommodationLayoutTable.getData(), id: this.ac.accommodation.id} : {id: this.ac.accommodation.id, data: null, others: []};
      if (this.internalAspectComponent) {
        _assetClassOffice.internalAspectData = this.internalAspectComponent.getData();
      }
      _assetClassOffice.grounds = {...this.acGroundsComponent.getData(), id: this.ac.grounds.id};
      this.uploadFileComponent.res$.pipe(take(1)).subscribe(value => {
          if (value) {
              _assetClassOffice.picture = value.success;
          }
      });
      _assetClassOffice.sizes = this.sizesSubject.value;
      _assetClassOffice.tenures = this.considerationAndSourceComponent ? this.considerationAndSourceComponent.getData() : [];
      if (this.acDocumentUploadComponent) {
        _assetClassOffice.documents = this.acDocumentUploadComponent.getDocuments();
      }
      if (this.buildingFileComponent) {
        this.buildingFileComponent.res$.pipe(take(1)).subscribe(value => {
            if (value) {
              _assetClassOffice.building_info.picture = value.success;
            }
        });
        _assetClassOffice.building_info.pictures = this.buildingFileComponent.uploadFiles;
      }
      if (this.buildingFormComponent) {
        _assetClassOffice.buildingInfo = this.buildingFormComponent.getData();
      }
      if (!this.isComplexForm) {
        _assetClassOffice.buildingInfo.id = this.ac.buildingInfo.id;
        _assetClassOffice.buildingInfo.infoSection.building_type = controls.building_type.value;
        _assetClassOffice.buildingInfo.infoSection.building_type_comment = controls.building_type_comment.value;
      }
      if (this.mapLocationComponent) {
        // Building ID is no longer asked for; the location block's Building Name / Number stands in for it
        const buildingName = this.mapLocationComponent.getData().building_name
        if (_assetClassOffice.building_info) {
          _assetClassOffice.building_info.building_name = buildingName
        }
        if (_assetClassOffice.buildingInfo?.infoSection) {
          _assetClassOffice.buildingInfo.infoSection.building_name = buildingName
        }
      }
      _assetClassOffice.esgIndicator = esgIndicatorValues
      return _assetClassOffice;
    }

    setNullWhenZero(value: any) {
      if (value === undefined || value === '0' || value === 0 || value === -1) {
        return null;
      } else {
        return value;
      }
    }
    setNullWhenNegOne(value: any) {
      if (value === -1) {
        return null;
      }
      return value;
    }

    /**
     * Create assignment
     *
     * @param _assetClassOffice: AssetClassOfficeModel
     */
    createAssetClassOffice(_assetClassOffice: AssetClassOfficeModel) {

      this.store.dispatch(new AssetClassOfficeOnServerCreated({
        assetClassOffice: _assetClassOffice,
        tenures: _assetClassOffice.tenures,
        sizes: _assetClassOffice.sizes,
        fileList: this.uploadFileComponent ? this.uploadFileComponent.uploadFiles : [],
        selectedFacilities: [],
        selectedFacilitiesExclusive: [],
        officeExternalAreas: [],
        documents: _assetClassOffice.documents 
      }));
      this.saveState = true;
      this.layoutUtilsService.showActionNotification('Saved the changes', MessageType.Update, 3000, true, false);
      this.location.back();

    }

    /**
     * Update assignment
     *
     * @param _assetClassOffice: AssetClassOfficeModel
     */
    updateAssetClassOffice(_assetClassOffice: AssetClassOfficeModel) {
      const updateAssignment: Update<AssetClassOfficeModel> = {
          id: _assetClassOffice.id,
          changes: _assetClassOffice
      };
      this.store.dispatch(new AssetClassOfficeOnServerUpdated({
        partialAssetClassOffice: updateAssignment,
        assetClassOffice: _assetClassOffice,
        tenures: _assetClassOffice.tenures,
        sizes: _assetClassOffice.sizes,
        fileList: this.uploadFileComponent ? this.uploadFileComponent.uploadFiles : [],
        selectedFacilities: [],
        selectedFacilitiesExclusive: [],
        officeExternalAreas: [],
        documents: _assetClassOffice.documents
      }));
      this.saveState = true;
      this.layoutUtilsService.showActionNotification('Saved the changes', MessageType.Update, 3000, true, false);
      this.location.back();
    }

    canDeactivate() {
      if (this.discard()) {
        if (window.confirm('Are you sure? All unsaved changes will be lost.')) {
          return true;
        } else {
          // ---------work around angular bug--------- reference: https://github.com/angular/angular/issues/13586
          const currentUrlTree = this.router.createUrlTree([], this.activatedRoute.snapshot);
          const currentUrl = currentUrlTree.toString();
          this.location.go(currentUrl);
          // ---------work around end-----------------
          return false;
        }
      }
      return true;
    }

    discard() {
      if (!this.saveState &&
        localStorage.getItem(environment.authTokenKey)) {
        return true;
      };
      return false;
    }
    onHasFormErrorsChange(obj: {hasFormErrors: boolean}) {
      this.hasFormErrors = obj.hasFormErrors;
    }

    navToList() {
      // this.router.navigate(['../'], {relativeTo: this.activatedRoute});
      const url = `${this.layoutConfigService.getCurrentMainRoute()}/comparable/offices`;
      this.router.navigate([url], {relativeTo: this.activatedRoute});
    }
    onTabChanged($event) {
      const activeIndex = $event.index;
    }
    onTabChange(index: number) {
      this.selectedTab = index;
    }
    changeTab(section: string) {
      const section_tab = [
        {sections: ['location', 'building'], tab_index: 0},
        {sections: ['prop'], tab_index: 1},
        {sections: ['consideration'], tab_index: 2},
        {sections: ['pic'], tab_index: 3},
      ]
      const active_Tab = section_tab.find(item => item.sections.includes(section));
      this.selectedTab = active_Tab ? active_Tab.tab_index : 0;
      this.selectedtabchange.next(this.selectedTab);
    }
    erroTabMap() {
      return this.typesUtilsService.getCompTabErrorMap(this.isComplexForm, this.error.fields, this.tabHeaders, 3);
    }

  onConsiderationsChange(considerations: AssetClassTenure[]) {
    if (considerations.length > 0) {
      this.considerationError$.next(false)
    } else {
      this.considerationError$.next(undefined)
    }
  }

  onCenterChangeV2(event: CoordinatePoint) {
    this.centerLat = event.latitude
    this.centerLng = event.longitude
  }
  onMarkerChangeV2(event: CoordinatePoint) {
    if (event == null) {
      return;
    }
  }
  private _setLocationInfo() {
    const latitude = toCoordinate(this.ac.locationData.latitude)
    const longitude = toCoordinate(this.ac.locationData.longitude)
    this.centerLat = latitude
    this.centerLng = longitude
    this.locationInfo = {
      latitude,
      longitude,
      city_id: this.ac.locationData.city_id,
      country_id: this.ac.locationData.country_id,
      zip_code: this.ac.locationData.zip_code,
      unit: this.ac.locationData.unit,
      building_name: this.ac.locationData.building_name,
      administrative_areas: this.ac.locationData.administrative_areas ?? [],
      streets: this.ac.locationData.streets ?? [],
      localities: this.ac.locationData.localities ?? [],
      location_surrounding: this.ac.locationData.location_surrounding
    }
  }
}

interface Item {
  name: string;
}

function filter<T extends Item>(data: T[], searchControl: UntypedFormControl): T[] {
  let search: string = searchControl.value;
  if (!search || search === '') {
    return data;
  } else {
    search = search.toLowerCase();
  }
  return data.filter(item => item.name.toLowerCase().indexOf(search) > -1);
}

function _deepCopy(arr: any[]): any[] {
  return arr.map(item => ({...item}));
}